<template>
  <div class="detailed-cell">
    <!-- 日期切换 -->
    <div class="bg-w">
      <span @click="onBeforeDateClick" class="usable">{{ "前一" + modelName }}</span>
      <span @click="onDateSpanClick" class="usable">{{ setDateOkText(datePickerValue) }}</span>
      <span @click="onNextDateClick" :class="nextDateClassName">{{ "后一" + modelName }}</span>
    </div>
    <!-- 交易类型列表 -->
    <div class="bg-w" v-for="(rows, idx) in table1" :key="'table1_' + idx">
      <div class="inline-cell" v-for="(item, k) in rows" :key="'table1_item_' + k">
        <div>
          <span>{{ item.date }}</span>
        </div>
        <div>
          <span>{{ item.name | shortText }}</span>
        </div>
      </div>
    </div>
    <div class="eye-row bg-w" v-if="isShowChannelData">
      <div class="title">
        <i class="icon" />
        <span>交易量</span>
      </div>
      <div class="eye" @click="changeDisplayHandler">
        <svg-icon :icon-class="imgEyePath" class-name="cur-icon"></svg-icon>
      </div>
    </div>
    <div v-if="isShowChannelData">
      <div class="bg-w" v-for="(rows, idx) in table2" :key="'table2_' + idx">
        <div class="inline-cell" v-for="(item, k) in rows" :key="'table2_item_' + k">
          <div>
            <span>{{ item.date }}</span>
          </div>
          <div>
            <span>{{ item.name | shortText }}</span>
          </div>
        </div>
      </div>
    </div>
    <mt-datetime-picker ref="datePicker" type="date" v-model="pickerValue" :endDate="new Date()" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日" @confirm="onDatePickerConfirm">
    </mt-datetime-picker>
  </div>
</template>

<script>
/* global PUBLIC_PRODUCT */

import { Indicator } from 'mint-ui';
import { CusToast } from '@/utils/CustomToast';
import { formatDate, formatDateYm } from '@/utils/utils';
import { GetReward, GetRewardBuschannel } from '@/api/reward';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';
import SvgIcon from './SvgIcon';

export default {
  name: 'DetailedList',
  props: ['flag', 'mark', 'actived'],
  comments: { SvgIcon },
  data() {
    return {
      imgEyePath: 'hide_money',
      dataList: [
        { name: '总交易额(元)', date: '0.00' },
        { name: '总交易笔数(笔)', date: '0' },
        { name: '新增代理商(人)', date: '0' },
        { name: '新增商户(人)', date: '0' },
        { name: '终端总数(台)', date: '0' },
        { name: '已激活终端总数(台)', date: '0' },
        { name: 'POS收款交易金额(元)', date: '0.00' },
        { name: 'POS收款交易笔数(笔)', date: '0' },
        { name: '银联云闪付交易金额(元)', date: '0.00' },
        { name: '银联云闪付交易笔数(笔)', date: '0' },
      ],
      channelListData: [],
      channelListStar: [
        // { name: "POS交易金额(元)", date: "****" },
        // { name: "POS交易笔数(笔)", date: "****" },
        // { name: "标准费率交易金额(元)", date: "****" },
        // { name: "标准费率交易笔数(笔)", date: "****" },
        // { name: "云闪付交易金额(元)", date: "****" },
        // { name: "云闪付交易笔数(笔)", date: "****" },
        // { name: "手机POS交易金额(元)", date: "****" },
        // { name: "手机POS交易笔数(笔)", date: "****" },
        // { name: "云闪付二维码交易金额(元)", date: "****" },
        // { name: "云闪付二维码交易笔数(笔)", date: "****" },
        // { name: "优选二维码交易金额(元)", date: "****" },
        // { name: "优选二维码交易笔数(笔)", date: "****" },
        // { name: "高级快捷交易金额(元)", date: "****" },
        // { name: "高级快捷交易笔数(笔)", date: "****" },
        // { name: "收款码收款交易金额(元)", date: "****" },
        // { name: "收款码收款交易笔数(笔)", date: "****" },
        // { name: "碰一下收款交易金额(元)", date: "****" },
        // { name: "碰一下收款交易笔数(笔)", date: "****" },
      ],
      table1: [],
      table2: [],
      modelName: '天',
      nextDateClassName: 'usable',
      pickerValue: null,
      datePickerValue: null,
      product: PUBLIC_PRODUCT.toLowerCase().trim(),
    };
  },
  watch: {
    actived(val) {
      // 判断当前组件是否被激活
      if (this.mark === val) {
        // 设置默认日期为当前日期
        this.datePickerValue = new Date();
        // 设置时间间隔
        this.modelName = this.mark === 1 ? '天' : '月';
        // 设置下一天/下一月按钮样式
        this.setNextDateClassName();
        // 加载数据
        this.initData();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      // 判断当前组件是否被激活
      if (this.mark === this.actived) {
        // 设置默认日期为当前日期
        this.datePickerValue = new Date();
        // 设置时间间隔
        this.modelName = this.mark === 1 ? '天' : '月';
        // 设置下一天/下一月按钮样式
        this.setNextDateClassName();
        // 加载数据
        this.initData();
      }
    });
  },
  computed: {
    currentSelectedDate() {
      const yyyy = this.datePickerValue.getFullYear();
      const MM = String(this.datePickerValue.getMonth() + 1).padStart(2, '0');
      const dd = String(this.datePickerValue.getDate()).padStart(2, '0');
      return yyyy + '-' + MM + '-' + dd + ' 00:00:00';
    },
    prevPageSelectedFlag() {
      return parseInt(this.flag);
    },
    parentSelectedMark() {
      return this.mark;
    },
    isShowChannelData() {
      return this.product !== 'cxyfzs';
    },
  },
  methods: {
    initData() {
      this.imgEyePath = 'hide_money';
      // 判断接口开关
      switch (this.$store.state.INTERFACE_ON_OFF) {
        case 'on':
          this.getReward();
          this.dataRebuildByChannel(this.channelListStar);
          break;
        case 'off':
          this.dataRebuild();
          break;
      }
    },
    getReward() {
      Indicator.open();
      GetReward({
        date: this.currentSelectedDate,
        flag: this.prevPageSelectedFlag,
        mark: this.parentSelectedMark,
      })
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.dataList = res.rows;
            this.dataRebuild();
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    getRewardBuschannel() {
      Indicator.open();
      GetRewardBuschannel({
        date: this.currentSelectedDate,
        flag: this.prevPageSelectedFlag,
        mark: this.parentSelectedMark,
      })
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.dataList2 = res.rows;
            this.dataRebuildByChannel(this.dataList2);
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    dataRebuild() {
      const n = 2;
      const len = this.dataList.length;
      const lineNum = len % n === 0 ? len / n : Math.floor(len / n + 1);
      this.table1 = [];
      for (let i = 0; i < lineNum; i++) {
        const obj = this.dataList.slice(i * n, i * n + n);
        this.table1.push(JSON.parse(JSON.stringify(obj)));
      }
    },
    dataRebuildByChannel(dataSet) {
      const n = 2;
      const len = dataSet.length;
      const lineNum = len % n === 0 ? len / n : Math.floor(len / n + 1);
      this.table2 = [];
      for (let i = 0; i < lineNum; i++) {
        const obj = dataSet.slice(i * n, i * n + n);
        this.table2.push(JSON.parse(JSON.stringify(obj)));
      }
    },
    setDateOkText(val) {
      if (val) {
        if (this.mark === 1) return val.getFullYear() + '年' + (val.getMonth() + 1) + '月' + val.getDate() + '日';
        else if (this.mark === 2) return val.getFullYear() + '年' + (val.getMonth() + 1) + '月';
      }
      return '';
    },
    openDatePicker() {
      this.pickerValue = this.datePickerValue;
      this.$refs.datePicker.open();
      if (this.mark === 2) {
        this.$refs.datePicker.$el.getElementsByClassName('picker-slot')[2].style.display = 'none';
      }
    },
    onDateSpanClick() {
      this.openDatePicker();
    },
    onDatePickerConfirm(val) {
      this.datePickerValue = val;
      this.setNextDateClassName();
      this.initData();
    },
    onBeforeDateClick() {
      const d = new Date(this.datePickerValue);
      if (this.mark === 1) this.datePickerValue = new Date(d.setDate(d.getDate() - 1));
      else if (this.mark === 2) this.datePickerValue = new Date(d.setMonth(d.getMonth() - 1, 1));
      this.setNextDateClassName();
      this.initData();
    },
    onNextDateClick() {
      if (this.nextDateClassName === 'usable') {
        const d = new Date(this.datePickerValue);
        if (this.mark === 1) this.datePickerValue = new Date(d.setDate(d.getDate() + 1));
        else if (this.mark === 2) this.datePickerValue = new Date(d.setMonth(d.getMonth() + 1, 1));
        this.setNextDateClassName();
        this.initData();
      }
    },
    setNextDateClassName() {
      const now_ymd = formatDate(new Date());
      const value_ymd = formatDate(this.datePickerValue);
      const now_ym = formatDateYm(new Date());
      const value_ym = formatDateYm(this.datePickerValue);
      if (this.mark === 1) this.nextDateClassName = now_ymd === value_ymd ? 'unusable' : 'usable';
      if (this.mark === 2) this.nextDateClassName = now_ym === value_ym ? 'unusable' : 'usable';
    },
    changeDisplayHandler() {
      if (this.imgEyePath === 'hide_money') {
        this.imgEyePath = 'show_money';
        this.getRewardBuschannel();
      } else {
        this.imgEyePath = 'hide_money';
        this.dataRebuildByChannel(this.channelListStar);
      }
    },
  },
  filters: {
    shortText(val) {
      if (val.length > 12) return val.substring(0, 12) + '…';
      return val;
    },
  },
};
</script>
